import React from 'react';
import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import useBillingStore from '../../stores/useBillingStore';
import './billing.css';

export default function ByokInvalidBanner() {
  const navigate = useNavigate();
  const billingPlan = useProjectStore((s) => s.billingPlan);
  const freeTierState = useProjectStore((s) => s.billingFreeTierState);
  const subscription = useBillingStore((s) => s.subscription);

  const state = freeTierState || subscription?.freeTier?.state;
  if (billingPlan !== 'FREE' || state !== 'BYOK_INVALID') {
    return null;
  }

  return (
    <div className="billing-app-banner-wrap">
      <div className="billing-app-banner-inner">
        <Alert severity="warning" className="billing-pending-banner">
          <div className="billing-banner-content">
            <span className="billing-banner-message">
              Your API key stopped working. Update your key or upgrade to Standard.
            </span>
            <div className="billing-banner-actions">
              <Button
                color="inherit"
                size="small"
                onClick={() => navigate('/organization')}
                className="billing-banner-action"
              >
                Update API key
              </Button>
              <Button
                color="inherit"
                size="small"
                onClick={() => navigate('/pricing')}
                className="billing-banner-action"
              >
                Upgrade to Standard
              </Button>
            </div>
          </div>
        </Alert>
      </div>
    </div>
  );
}
